module.exports = __webpack_public_path__ + "img/sld_mfm_spare_1_t1_b1_dark.b6284504.svg";